export const producerIsLoadingSelector = state => state.producers.createProducer.isLoading